/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const setSliderArrowTop = (s) => {
		let img = document.querySelector("." + s +"-item-img img");
		if(img) {
			let btn01 = document.querySelector("." + s +"-control .swiper-button-next");
			let btn02 = document.querySelector("." + s +"-control .swiper-button-prev");

			btn01.style.top = img.height / 2 + "px";
			btn02.style.top = img.height / 2 + "px";
		}
	}

	const slider = () => {
		if(document.querySelectorAll('.top-slider01').length) {
			const topslider01 = new Swiper('.top-slider01', {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				loopAdditionalSlides: 0,
				speed: 1000,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.top-slider01-control .swiper-pagination',
					clickable: true,
				},
				breakpoints: {
					769: {
						loop: false,
						slidesPerView: 3,
						spaceBetween: 20,
						centeredSlides: false,
					},
				},
			});
			document.querySelector('.top-slider01-control-button').addEventListener('click', (e) => {
				if(!(e.currentTarget.classList.contains(a))) {
					e.currentTarget.ariaLabel = '停止';
					e.currentTarget.classList.add(a);
					topslider01.autoplay.start();
				} else {
					e.currentTarget.ariaLabel = '再生';
					e.currentTarget.classList.remove(a);
					topslider01.autoplay.stop();
				}
			});
			setTimeout(() => {
				document.querySelector('.top-slider01-control').classList.remove('is-o0');
			}, 600);
		}
		if(document.querySelectorAll('.top-slider02').length) {
			const topslider02 = new Swiper('.top-slider02', {
				slidesPerView: 1,
				spaceBetween: 30,
				centeredSlides: true,
				loop: true,
				loopAdditionalSlides: 1,
				speed: 1000,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.top-slider02-control .swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.top-slider02-control .swiper-button-next',
					prevEl: '.top-slider02-control .swiper-button-prev',
				},
				breakpoints: {
					769: {
						loop: false,
						slidesPerView: 3,
						spaceBetween: 28,
						centeredSlides: false,
					},
				},
				on: {
					init: (swiper) => {
						let slides = swiper.slides;
						if(slides.length > swiper.loopedSlides) {
							const wrapper = swiper.wrapperEl
							slides.forEach(function (ele) {
								wrapper.append(ele.cloneNode(true));
							})
						}
					},
					// afterInit: (swiper) => {
					// 	setTimeout(() => {
					// 		const paginations = swiper.pagination.bullets;
					// 		alert(paginations.length);
					// 		paginations.forEach((ele, index) => { 
					// 			if(index > (paginations.length / 2) - 1){
					// 				ele.remove()
					// 			}
					// 		})
					// 	},1000);
					// }
				}
			});
			document.querySelector('.top-slider02-control-button').addEventListener('click', (e) => {
				if(!(e.currentTarget.classList.contains(a))) {
					e.currentTarget.ariaLabel = '停止';
					e.currentTarget.classList.add(a);
					topslider02.autoplay.start();
				} else {
					e.currentTarget.ariaLabel = '再生';
					e.currentTarget.classList.remove(a);
					topslider02.autoplay.stop();
				}
			});
			setTimeout(() => {
				setSliderArrowTop("top-slider02");
				document.querySelector('.top-slider02-control').classList.remove('is-o0');
			}, 600);
			window.addEventListener('resize', () => {
				let resizeTime = 0;
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => {
					setSliderArrowTop("top-slider02");
				}, 300);
			});
		}
		if(document.querySelectorAll('.top-slider03').length) {
			const topslider03 = new Swiper('.top-slider03', {
				slidesPerView: 1,
				spaceBetween: 30,
				loop: true,
				loopAdditionalSlides: 0,
				speed: 1000,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.top-slider03-control .swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.top-slider03-control .swiper-button-next',
					prevEl: '.top-slider03-control .swiper-button-prev',
				},
				breakpoints: {
					769: {
						loop: false,
						slidesPerView: 3,
						spaceBetween: 10,
						centeredSlides: false,
					},
				},
			});
			document.querySelector('.top-slider03-control-button').addEventListener('click', (e) => {
				if(!(e.currentTarget.classList.contains(a))) {
					e.currentTarget.ariaLabel = '停止';
					e.currentTarget.classList.add(a);
					topslider03.autoplay.start();
				} else {
					e.currentTarget.ariaLabel = '再生';
					e.currentTarget.classList.remove(a);
					topslider03.autoplay.stop();
				}
			});
			setTimeout(() => {
				setSliderArrowTop("top-slider03");
				document.querySelector('.top-slider03-control').classList.remove('is-o0');
			}, 600);
			window.addEventListener('resize', () => {
				let resizeTime = 0;
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => {
					setSliderArrowTop("top-slider03");
				}, 300);
			});
		}
	}

	let tabSwitch = () => {
		let tab = document.querySelectorAll('.js-tab');
		let content = document.querySelectorAll('.js-tab-content');
		if (tab.length) {
			// ハッシュタグで絞り込み
			if (location.hash) {
				let hash = location.hash.split('#')[1];
				tab.forEach(ele => {
					ele.classList.remove(a);
					if (ele.getAttribute('data-target').match(hash)) {
						ele.classList.add(a);
					}
				});
				content.forEach(ele => {
					ele.classList.remove(a);
					ele.classList.remove(v);
					if (ele.getAttribute('data-target').match(hash)) {
						ele.classList.add(a);
						setTimeout(() => { ele.classList.add(v); }, 200);
					} else {
					}
				});
			}		
		}
	}
	const tabBtns = document.querySelectorAll('button.top-product-tab-button');
	tabBtns.forEach(function(btn) {
		btn.addEventListener('mouseover', function(e) {
			if(e.currentTarget.parentNode.classList.contains(a)) {
				return
			}
			location.hash = e.currentTarget.parentNode.dataset.target;
			tabSwitch();
			// console.log(location.hash)
			// console.log(e.currentTarget)
		});
	});

	if(document.querySelectorAll('.top-video-control-button').length) {
		document.querySelectorAll('.top-video-control-button').forEach(function(btn){

			btn.addEventListener('click',function(e){
				var videoElm = document.getElementById(e.currentTarget.dataset.videoid);

				// console.log(e.currentTarget.dataset.videoid)
				// console.log(videoElm)
				if(!(e.currentTarget.classList.contains(a))) {
					e.currentTarget.ariaLabel = '停止';
					e.currentTarget.classList.add(a);
					videoElm.play();
				} else {
					e.currentTarget.ariaLabel = '再生';
					e.currentTarget.classList.remove(a);
					videoElm.pause();
				}
		
			});
		});
	}
	slider();

	const setIframe = () => {
		let iframeElm = document.querySelector("#js-iframe-e");
		if(iframeElm) {
			EurolandToolIntegrationObject.set("js-iframe-e");
		}
	}
	document.addEventListener('DOMContentLoaded', function() {
		setIframe();
	});

})(window.FUNCTIONS);
